import { render, staticRenderFns } from "./copy-form-url-button-render.vue?vue&type=template&id=a821b612&scoped=true"
import script from "./copy-form-url-button-render.vue?vue&type=script&lang=js"
export * from "./copy-form-url-button-render.vue?vue&type=script&lang=js"
import style0 from "./copy-form-url-button-render.vue?vue&type=style&index=0&id=a821b612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821b612",
  null
  
)

export default component.exports